:host {
  position: relative;
  display: flex;
  align-items: center;
  border-radius: var(--textarea-radius, var(--radius-l, $radius-l));
  border: 1px solid var(--border-color-primary, border-color('primary'));
  background: var(--background-color-secondary, background-color('secondary'));
  box-shadow: var(--textarea-shadow, var(--shadow-color-primary, shadow-color('primary')));
  padding: var(--spacing-xs, $spacing-xs) var(--spacing-xs, $spacing-xs) var(--spacing-xs, $spacing-xs) var(--spacing-m, $spacing-m);
}

::slotted([slot='adornment-end']) {
  display: flex;
  align-items: center;
  justify-content: center;
}

.textarea {
  @include paragraph();
  left: 0;
  right: 0;
  resize: none;
  border: none;
  outline: none;
  background: none;
  font-family: inherit;
  color: var(--text-color-primary, text-color('primary'));
  width: 100%;
  padding: 0;
  font-size: var(--font-size-sm, $font-size-sm);

  transition: height 0.1s;

  @media (--sm-min) {
    padding: var(--spacing-s, $spacing-s) 0;
  }

  &::placeholder {
    color: var(--text-color-inactive, text-color('inactive'));
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 95%;
  }

  &:focus-visible {
    border-color: var(--border-color-accent, border-color('accent'));
    outline: none;
  }

  // Maybe move somewhere else to reuse in some somponents, but not globally
  &::-webkit-scrollbar {
    width: 0.3em;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #b2b2b285;
    border-radius: var(--border-radius-l, $radius-l);
  }

  @media (--sm-min) {
    font-size: var(--font-size-md, $font-size-md);
  }
}
